import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 31 31"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "15.5",
  cy: "15.5",
  r: "15.5",
  fill: "#F5F5F5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#36A635",
  d: "m19.85 10.605-6.526 6.363-2.175-2.12-2.175 2.12 4.35 4.243 8.702-8.485z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }